import closeCrossIcon from "./images/close_cross_icon.svg";
import homeIcon from "./images/home_icon.svg";
import powerIcon from "./images/power_icon.svg";
import profileIcon from "./images/profile_icon.svg";
import trashIcon from "./images/trash_icon.svg";
import facebookLogo from "./images/facebook.svg";
import appBrandLogo from "./images/full_brand_logo.svg";
import instagramLogo from "./images/instagram.svg";
import arrowDownIcon from "./images/arrow_down_icon.svg";
import arrowUpIcon from "./images/arrow_up_icon.svg";
import errorIcon from "./images/error_icon.svg";
import boldCrossIcon from "./images/bold_cross_icon.svg";
import filterCircleIcon from "./images/filter_circle_icon.svg";
import cartPlusFillIcon from "./images/cart_plus_fill_icon.svg";
import searchIcon from "./images/search_icon.svg";
import arrowRightIcon from "./images/arrow_right_icon.svg";
import piggyBankIcon from "./images/piggy_bank_icon.svg";
import minusIcon from "./images/minus_icon.svg";
import plusIcon from "./images/plus_icon.svg";
import topArrowIndicatorIcon from "./images/top_arrow_indicator_icon.svg";
import CheckIcon from "./images/check_icon.svg";
import arrowLeftIcon from "./images/arrow_left_icon.svg";
import pinkTagIcon from "./images/pink_tag_icon.svg";
import confirmationPinkIcon from "./images/confirmation_pink_icon.svg";
import infoIcon from "./images/info_icon.svg";
import printerIcon from "./images/printer_icon.svg";
import downloadIcon from "./images/download_icon.svg";
import unionIcon from "./images/union_icon.svg";
import starIcon from "./images/star_icon.svg";
import starDisbledIcon from "./images/star_disbled_icon.svg";
import cartCheck from "./images/cart_check.svg";
import cartPlus from "./images/cart_plus.svg";
import eyeView from "./images/eye_view.svg";
import appFooterBrandLogo from "./images/footer_brand_logo.svg";

export const LOGO = {
  facebookLogo,
  appBrandLogo,
  instagramLogo,
  appFooterBrandLogo,
};

export const ICON = {
  homeIcon,
  profileIcon,
  powerIcon,
  closeCrossIcon,
  homeIcon,
  arrowRightIcon,
  powerIcon,
  profileIcon,
  trashIcon,
  arrowDownIcon,
  arrowUpIcon,
  errorIcon,
  boldCrossIcon,
  filterCircleIcon,
  cartPlusFillIcon,
  searchIcon,
  piggyBankIcon,
  minusIcon,
  plusIcon,
  topArrowIndicatorIcon,
  CheckIcon,
  arrowLeftIcon,
  pinkTagIcon,
  confirmationPinkIcon,
  infoIcon,
  printerIcon,
  downloadIcon,
  unionIcon,
  starIcon,
  starDisbledIcon,
  cartCheck,
  cartPlus,
  eyeView,
};
